var light = {
  dropShadow1: '0px 0px 4px rgba(0, 0, 0, 0.08)',
  dropShadow2: '0px 0px 8px rgba(0, 0, 0, 0.08)',
  dropShadow3: '0px 0px 20px rgba(0, 0, 0, 0.08)'
};
var dark = {
  dropShadow1: '0px 0px 4px rgba(0, 0, 0, 0.2)',
  dropShadow2: '0px 0px 8px rgba(0, 0, 0, 0.2)',
  dropShadow3: '0px 0px 20px rgba(0, 0, 0, 0.2)'
};
export var systemDropShadows = {
  light: light,
  dark: dark
};